// extracted by mini-css-extract-plugin
export default {"canvasContainer":"DrawPixels_canvasContainer__pLIXu","colorBtn":"DrawPixels_colorBtn__eSGwu","container":"DrawPixels_container__s4X80","drawButton":"DrawPixels_drawButton__BafCR"};